import { MODEL_ID } from 'Pods/ThreeDStudio/Store/constants'

const PROVIDER_KEY = 'tencent_hunyuan'

/**
 * Inverse of parseTencentMeshSegmentationProData. Builds an openedModel-shaped
 * payload for a just-submitted segmentation run so it can be reopened without an
 * extra API round-trip. Segmentation takes only input_3d, so there are no
 * settings to capture - providerRunAttributes stays empty.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseTencentMeshSegmentationProData
 */
export const buildTencentMeshSegmentationProFromState = (state, id) => ({
  id,
  providerKey: PROVIDER_KEY,
  providerModelId: MODEL_ID.TENCENT_MESH_SEGMENTATION_PRO,
  providerRunAttributes: {},
})
